// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-rootwidget .timeline-container[data-v-6466453a] {\n  padding-left: 1rem;\n  width: calc(100% - 1rem);\n}\n", ""]);
// Exports
module.exports = exports;
